
var Mediator = require('./Mediator.js');
var util = require('../util.js');
var storeHelper = require('../storeHelper');
var i18nHelper = require('../i18n');
var MOUSE_STATE = {'DOWN': 'down', 'MOVE': 'move', 'RELEASE': 'release'};

function compare(propertyName) {
  return function (object1, object2) {
    var value1 = object1.data[propertyName];
    var value2 = object2.data[propertyName];
    if (value2 < value1) {
      return 1;
    }
    else if (value2 > value1) {
      return -1;
    }
    else {
      return 0;
    }
  }
}


/**
 * 管理撤销、反撤销、保存、加载等数据操作
 */
var Data = {
  states: [],
  recycler: [],

  isSavable: function() {
    var localData = this.getLocalData2();
    var layers = localData.localLayers;
    var ids = localData.localIds;
    if(ids.length > 0) {
      return true;
    }
    for(var i=0;i<layers.length;i++) {
      var layer = layers[i];
      if(layer.data.id === -1) {
        return true;
      }
      if(layer.data.isChanged) {
        return true;
      }
    }
    return false;
  },
  isUndoable: function() {
    if(this.states.length > 1) {
      return true;
    }
    return false;
  },
  isRedoable: function() {
    if(this.recycler.length > 0) {
      return true;
    }
    return false;
  },

  initStates: function() {
    var init = function() {
      Data.states = [];
      Data.recycler = [];
      Data.restore2();
    };
    //从服务器加载完毕初始化数据
    if(storeHelper.get('loadState') === 'done' || storeHelper.get('loadState') === 'failed') {
      init();
      storeHelper.set('loadState', 'init');
    }
    //所有数据保存完毕，重新初始化回退栈
    if(this.saveDone && storeHelper.get('saveState') === 'done') {
      init();
      storeHelper.set('saveState', 'init');
    }
  },
  rollBack2: function() {
    //只剩下初始化时的状态时，不进行撤销
    if(this.states.length <= 1) {
      return;
    }
    //最多支持撤销20个操作
    if(this.states.length > 20) {
      this.states.splice(0, 1);
    }
    var state = this.states.pop();
    if (state) {
      Mediator.reset();
      this.recycler.push(state);
      var drawData = this.states[this.states.length - 1].layers;
      var ids = this.states[this.states.length - 1].ids;
      this.setLocalData2(drawData, ids);
    }
  },
  reRollBack2: function() {
    Mediator.reset();
    var state = this.recycler.pop();
    if (state) {
      this.states.push(state);
      var drawData = state.layers;
      var ids = state.ids;
      this.setLocalData2(drawData, ids);
    }
  },
  restore2: function() {
    var localLayers = [];
    var layers = $(Mediator.getCanvas()).getLayers();
    for (var i = 0; i < layers.length; i++) {       //将所有数据放在本地，用以load时合并到服务器数据
      var layer = layers[i];
      if (layer.groups[0] === 'points') {
        continue;
      }
      var data = Mediator.getToolByLayer(layers[i]).exportData(layers[i]);
      if (data) {
        localLayers.push(data);
      }
    }
    var localIds = this.getLocalData2().localIds;
    //当前状态数据放到本地
    this.setLocalData2(localLayers, null);
    //保存一个当前快照，清空Redo栈
    this.states.push({layers: localLayers, ids: localIds});
    this.recycler = [];
  },
  loadData2: function() {
    var review = Mediator.getProps('review');
    var layerObjs = [];
    for(var i=0;i<review.length;i++) {
      var layerStr = review[i].data;
      var layerObj = null;
      try {
        layerObj = JSON.parse(layerStr);
      } catch (err) {
        console.log('json解析错误!');
      }
      layerObj.data.id = review[i].id;
      layerObj.data.isChanged = false;
      layerObjs.push(layerObj);
    }
    var drawData = this.mergeData2(layerObjs);
    this.reDraw2(drawData);
  },
  //将本地数据合并到服务器数据
  mergeData2: function(layerObjs) {
    var localData = this.getLocalData2();
    var layers = localData.localLayers;
    var ids = localData.localIds;
    for(var i=0;i<layers.length;i++) {
      var failedLayer = layers[i];
      if(failedLayer.data.id === -1) {      //新增数据
        this.isNeedSave = true;
        layerObjs.push(failedLayer);
      } else if(failedLayer.data.isChanged){                              //修改数据
        for(var j=0;j<layerObjs.length;j++) {
          var layer = layerObjs[j];
          if(failedLayer.data.id === layer.data.id) {
            this.isNeedSave = true;
            layerObjs[j] = failedLayer;
            break;
          }
        }
      }
    }
    for(var i=0;i<ids.length;i++) {         //去掉已经删除的数据
      var failedId = ids[i];
      for(var j=0;j<layerObjs.length;j++) {
        var layer = layerObjs[j];
        if(failedId === layer.data.id) {
          this.isNeedSave = true;
          layerObjs.splice(j,1);
          break;
        }
      }
    }
    return layerObjs;
  },
  reDraw2: function(drawData) {
    var location = Mediator.getProps('fullPageLocation');
    Mediator.clearAll();
    if (drawData) {
      //按照索引排序，保证图层间顺序
      drawData.sort(compare("index"));
      for (var i = 0; i < drawData.length; i++) {
        var data = drawData[i];
        //以页面左上角为基准，偏移图层
        Mediator.getToolByLayer(data).reloadData(data, location);
        $(Mediator.getCanvas()).addLayer(data);
      }

      Mediator.setLayerEvents();
      $(Mediator.getCanvas()).drawLayers();
      Mediator.checkCurrent();
    }
  },
  getLocalData2: function() {
    var syncID = Mediator.getProps('syncID');
    var syncVersion = Mediator.getProps('syncVersion');
    var ID = Mediator.getProps('ID');
    var local = storeHelper.get('local');
    var result = {
      localLayers: [],
      localIds: [],
    };
    if(local) {
      var obj = JSON.parse(local);
      for(var i=0;i<obj.length;i++) {
        var pageData = obj[i];
        if(pageData.syncID === syncID &&
            pageData.syncVersion === syncVersion &&
            pageData.ID === ID) {
          result = {localLayers: pageData.localLayers, localIds: pageData.localIds};
        }
      }
    }
    return result;
  },
  setLocalData2: function(layers, ids) {
    var syncID = Mediator.getProps('syncID');
    var syncVersion = Mediator.getProps('syncVersion');
    var ID = Mediator.getProps('ID');
    var local = storeHelper.get('local');
    var obj = [];
    if(local) {
      obj = JSON.parse(local);
    }
    var data = {
      syncID: syncID,
      syncVersion: syncVersion,
      ID: ID,
      localLayers: layers?layers:[],
      localIds: ids?ids:[],
    };
    var isNew = true;
    for(var i=0;i<obj.length;i++) {
      var pageData = obj[i];
      if(pageData.syncID === syncID &&
          pageData.syncVersion === syncVersion &&
          pageData.ID === ID) {
        if(layers) {
          obj[i].localLayers = layers;
        }
        if(ids) {
          obj[i].localIds = ids;
        }
        isNew = false;
      }
    }
    if(isNew) {
      obj.push(data);
    }
    storeHelper.set('local', JSON.stringify(obj));
  },

  addLayers: [],
  updateLayers: [],
  deleteIds: [],
  failedLayers: [],
  failedIds: [],
  savingLayer: null,
  deletingId: null,
  saveDone: true,
  saveTotal: 0,
  doneNum: 0,
  startSave2: function() {
    this.saveDone = false;

    //正在保存的图层和id，用以保存失败的时候获取
    this.savingLayer = null;
    this.deletingId = null;

    //保存失败的图层和ids，成功的数据从本地清除
    this.failedLayers = [];
    this.failedIds = [];

    var localData = this.getLocalData2();
    for(var i=0;i<localData.localLayers.length;i++) {
      var layer = localData.localLayers[i];
      if(layer.data.author !== Data.getAuthor()) {
        continue;
      }
      if(layer.data.id === -1) {
        this.addLayers.push(layer);
        this.saveTotal++;
      } else if(layer.data.isChanged) {
        this.updateLayers.push(layer);
        this.saveTotal++;
      }
    }
    this.deleteIds = localData.localIds;
    this.saveTotal += this.deleteIds.length;
    Mediator.sendRequest();
  },
  handleSave2: function() {
    //记录下保存失败的数据，放在本地
    if(storeHelper.get('saveState') === 'failed') {
      if(this.savingLayer) {
        this.failedLayers.push(this.savingLayer);
        this.savingLayer = null;
      }
      if(this.deletingId) {
        this.failedIds.push(this.deletingId);
        this.deletingId = null;
      }
      storeHelper.set('saveState', 'done');
    }
    //保存一个数据，更新一次本地数据。本地数据用以修正服务器数据。
    if(storeHelper.get('saveState') === 'done') {
      var layers = [];
      var ids = [];
      for(var i=0;i<this.addLayers.length;i++) {
        layers.push(this.addLayers[i]);
      }
      for(var i=0;i<this.updateLayers.length;i++) {
        layers.push(this.updateLayers[i]);
      }
      for(var i=0;i<this.deleteIds.length;i++) {
        ids.push(this.deleteIds[i]);
      }
      for(var i=0;i<this.failedLayers.length;i++) {
        layers.push(this.failedLayers[i]);
      }
      for(var i=0;i<this.failedIds.length;i++) {
        ids.push(this.failedIds[i]);
      }
      this.setLocalData2(layers, ids);

      this.doneNum++;
      //上一条数据请求完且还有待处理数据，开始请求下一条数据（一条数据一个请求）
      if(!this.saveDone) {
        Mediator.sendRequest();
      }
    }

  },
  sendRequest2: function(add, update, remove) {
    while(true) {
      if(this.addLayers.length === 0) {
        break;
      }
      var layer = this.addLayers.pop();
      this.savingLayer = layer;
      add(layer);
      return;
    }
    while(true) {
      if(this.updateLayers.length === 0) {
        break;
      }
      var layer = this.updateLayers.pop();
      this.savingLayer = layer;
      update(layer.data.id, layer.data.author, layer);
      return;
    }
    while(true) {
      if(this.deleteIds.length === 0) {
        break;
      }
      var id = this.deleteIds.pop();
      if(id) {
        this.deletingId = id;
        remove(Data.getAuthor(), id);
        return;
      }
    }

    this.setSaveResult();
    this.saveDone = true;
  },

  saveSuccess: true,
  saveErrMsg: '',
  setSaveResult: function() {
    if(this.failedIds.length === 0 && this.failedLayers.length === 0) {
      this.saveErrMsg = '';
      this.saveSuccess = true;
    } else {
      this.saveErrMsg = (this.failedIds.length+this.failedLayers.length) + i18nHelper.get('SAVE_FAILED_MSG');
      this.saveSuccess  = false;
    }
  },

  deleteLayer: function(ids) {
    if(ids.length > 0) {
      var newIds = this.getLocalData2().localIds;
      for(var i=0;i<ids.length;i++) {
        if(ids[i] !== -1) {
          if(newIds.indexOf(ids[i]) === -1) {
            newIds.push(ids[i]);
          }
        }
      }
      this.setLocalData2(null, newIds);
      Mediator.restore();
    }
  },

  clearLocal: function() {
    if(this.saveSuccess) {
      this.setLocalData2([], []);
    }
  },

  getAuthor: function () {
    return storeHelper.get('sign');
  },
};

module.exports = Data;


// WEBPACK FOOTER //
// ./src/helper/Review/PaintData.js